<template>
    <div>
        <div >
<!--            <button v-status="meta.permission_prefix + 'edit'"-->
<!--                    class="btn btn-outline-primary btn-sm m-1" @click="action(data, 'show')"><i class="fa fa-pencil-alt"></i></button>-->

<!--          <a href="mostafa boro">مصطفی برو</a>-->
          <span class='badge-success badge-pill cursor-pointer' @click="action(data, 'show')"> {{this.data.user.name+" "+this.data.user.lastName}}</span>



<!--            <button v-status="meta.permission_prefix + 'delete'"-->
<!--                    class="btn btn-outline-danger btn-sm m-1" @click="action(data, 'delete')"><i class="fa fa-trash"></i></button>-->
        </div>
    </div>
</template>

<script>
export default {
  mounted() {

  },

  props: {
        data:{},
        action:{
            type:Function
        },meta:{
            type:Object
        }
    },



}
</script>
